module.exports = __webpack_public_path__ + "img/zx12.a99f9f83.png";